export default "__VITE_ASSET__EOK8NlVP__"